<template>
  <div class="form-group">
    <label
      class="control-label col-sm-2"
      :for="id"
    > {{ label }} </label>
    <div class="col-sm-10">
      <select
        :id="id"
        class="form-control"
        :value="value"
        @input="$emit('input', parseInt($event.target.value))"
      >
        <option
          v-for="program in available_programs"
          :value="parseInt(program['id'])"
        >
          {{ program['name'] }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { defaultErrorMessage } from '@/helpers'

export default {
  // this component provides a simple way to provide a program_selector in vue
  // it makes a call to the backend to retrieve the available programs

  props: {
    id: {
      required: true,
    },
    label: {
      default: '',
    },
    value: Number,
    url: {
      required: true,
      type: String,
    },
  },

  data () {
    return {
      available_programs: [],
    }
  },

  mounted () {
    axios.post(this.url, {}).then((response) => {
      this.available_programs = response.data.data.data

      // set the first program as the default value
      this.$emit('input', this.available_programs[0]['id'])
    }).catch(error => defaultErrorMessage(error))
  },
}
</script>
